export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: (state) => state.all,
    find: (state) => (id) => state.all.find((campaign) => campaign.id == id),
    loading: (state) => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, campaigns) {
      state.all = campaigns
      state.loading = false
    },
    set(state, campaign) {
      state.all = state.all.filter((o) => o.id != campaign.id)
      state.all.push(campaign)
    },
    remove(state, id) {
      state.all = state.all.filter((o) => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('client/campaigns')
        .then(
          (response) => commit('setAll', response.data),
          (response) => commit('stopLoading')
        )
    },
    fetch({ commit }, id) {
      return Vue.$http
        .get(`client/campaigns/${id}`)
        .then((response) => commit('set', response.data))
    },
    create({ commit }, campaign) {
      return Vue.$http.post('client/campaigns', { campaign }).then(
        ({data}) => { return Object.assign(campaign, data) },
        ({data}) => { return data }
      )
    },
    update({ commit }, campaign) {
      return Vue.$http
        .patch(`client/campaigns/${campaign.slug}`, { campaign })
        .then(({ data }) => {
          commit('set', data)
        })
        .catch(error => {
          return error
        })
    },
    destroy({ commit }, slug) {
      return Vue.$http
        .delete(`client/campaigns/${slug}`)
        .then((response) => commit('remove', slug))
    }
  }
}
